<div class="dialog-base">
  <div class="dialog-title">
    {{ 'feedBack.submitUpdates' | xTranslate }}
    <mat-icon (click)="closePopup()" class="float-right">close</mat-icon>
  </div>
  <div class="titile-border"></div>
  <form [formGroup]="feedbackForm" (ngSubmit)="onSubmit()" class="fx--padding-8">
    <mat-form-field
      appearance="outline"
      class="mt-10 miq-form-input no-error-pristine"
      [ngClass]="{ 'ng-invalid': feedbackForm.get('feedback_notes')?.dirty }"
    >
      <textarea
        formControlName="feedback_notes"
        class="feedback"
        matInput
        [placeholder]="'feedBack.pleaseUpdate' | xTranslate"
      ></textarea>
    </mat-form-field>
    <button mat-flat-button color="primary" class="submit-update" [disabled]="feedbackForm.invalid">SUBMIT</button>
  </form>
</div>

<ng-container *ngIf="isLoading">
  <cbre-spinner-loading-indicator></cbre-spinner-loading-indicator>
</ng-container>
